import { z } from "zod";

export const PricingTierSchema = z.object({
  code: z.string().min(1).max(40),
  name: z.string().min(1).max(60),
  tagline: z.string().max(160).optional(),
  currency: z.string().length(3).default("USD"),
  /** Prices in minor units (cents). `null` = contact sales. */
  price_monthly: z.number().int().nonnegative().nullable(),
  price_yearly: z.number().int().nonnegative().nullable(),
  seats: z.number().int().positive(),
  features: z.array(z.string().min(1).max(120)).max(20),
  highlight: z.boolean().default(false),
  cta_label: z.string().max(40).default("Start"),
  /** Enterprise tiers route to the contact form instead of Stripe Checkout. */
  contact_sales: z.boolean().default(false),
  stripe_price_monthly_id: z.string().optional(),
  stripe_price_yearly_id: z.string().optional(),
  sort: z.number().int().default(0),
});
export type PricingTier = z.infer<typeof PricingTierSchema>;
export type PricingTierInput = z.input<typeof PricingTierSchema>;

export const PricingTableSchema = z.array(PricingTierSchema);
